import React from "react";
import TopBar from "./TopBar";

export default function Page({ title, back = false, children }) {
  return (
    <>
      <TopBar title={title} showBack={back} />
      <main className="mx-auto max-w-screen-2xl px-4 py-4">{children}</main>
    </>
  );
}
